import React, { useEffect, useState, useRef } from 'react';

const CustomHighlightTarget = (props) => {
  const { selectionRegion, selectionData } = props;
  const [lastSelectedRange, setLastSelectedRange] = useState(null);
  const shiftPressed = useRef(false);

  useEffect(() => {
    const handleMouseUp = () => {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);

        if (shiftPressed.current && lastSelectedRange) {
          const newRange = document.createRange();
          newRange.setStart(lastSelectedRange.startContainer, lastSelectedRange.startOffset);
          newRange.setEnd(range.endContainer, range.endOffset);
          selection.removeAllRanges();
          selection.addRange(newRange);
          setLastSelectedRange(newRange);
        } else {
          setLastSelectedRange(range);
        }

        const container = document.createElement('div');
        container.appendChild(selection.getRangeAt(0).cloneContents());
        const selectedHTML = container.innerHTML;
        const selectedText = htmlToPlainText(selectedHTML);
        // console.log('Selected HTML:', selectedHTML);
        console.log('Selected Text: length', selectedText.length, 'TEXT:', selectedText);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Shift') {
        shiftPressed.current = true;
      }
    };

    const handleKeyUp = (event) => {
      if (event.key === 'Shift') {
        shiftPressed.current = false;
      }
    };

    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);

    return () => {
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, [lastSelectedRange, selectionData, selectionRegion]);

  const htmlToPlainText = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  return null;
};

export default CustomHighlightTarget;
